const GC = window.__GENERATED_CONSTANTS__

export const BASE_PATH = GC.BASE_PATH
export const CURRENT_PRODUCT = GC.CURRENT_PRODUCT
export const isOlVersion = window.isOlVersion
export const isDemoVersion = window.isDemoVersion

export const Product = {
    actiTIME: GC.Product.actiTIME,
    actiPLANS: GC.Product.actiPLANS,
}

export const UserHierarchyAssignmentType = {
    WORK: GC.UserHierarchyAssignmentType.WORK,
    MANAGEMENT: GC.UserHierarchyAssignmentType.MANAGEMENT
}

export const UserHierarchyAssignmentEntityType = {
    CUSTOMER: GC.UserHierarchyAssignmentEntityType.CUSTOMER,
    PROJECT: GC.UserHierarchyAssignmentEntityType.PROJECT,
    TASK: GC.UserHierarchyAssignmentEntityType.TASK
}

export const CopyWorkAssignmentOptions = {
    APPEND: GC.CopyWorkAssignmentOptions.APPEND,
    OVERWRITE: GC.CopyWorkAssignmentOptions.OVERWRITE,
}

export const EntityType = {
    CUSTOMER: GC.EntityType.CUSTOMER,
    PROJECT: GC.EntityType.PROJECT,
    TASK: GC.EntityType.TASK
}

export const BulkMoveTypes = {
    TO_OPEN: GC.BulkMoveTypes.TO_OPEN,
    ARCHIVED_TO_ARCHIVED: GC.BulkMoveTypes.ARCHIVED_TO_ARCHIVED,
    OPEN_TO_ARCHIVED_WITH_COMPLETION: GC.BulkMoveTypes.OPEN_TO_ARCHIVED_WITH_COMPLETION,
    OPEN_TO_ARCHIVED_WITH_RESTORE: GC.BulkMoveTypes.OPEN_TO_ARCHIVED_WITH_RESTORE,
}

export const CustomersProjectsSelectionQualifier = {
    ALL: GC.CustomersProjectsSelectionQualifier.ALL,
    ALL_ACTIVE: GC.CustomersProjectsSelectionQualifier.ALL_ACTIVE,
    SELECTED: GC.CustomersProjectsSelectionQualifier.SELECTED
}

export const AccessRights = {
    MANAGE_USERS: GC.AccessRight.MANAGE_USERS,
    SUBMIT_OTHER_USER_TIME_TRACK: GC.AccessRight.SUBMIT_OTHER_USER_TIME_TRACK,
    EDIT_HIERARCHY: GC.AccessRight.EDIT_HIERARCHY,
    GENERATE_MONEY_REPORTS: GC.AccessRight.GENERATE_MONEY_REPORTS,

    SUBMIT_TIME_TRACK: GC.AccessRight.SUBMIT_TIME_TRACK,
    LOCK_TIME_TRACK: GC.AccessRight.LOCK_TIME_TRACK,
    MANAGE_PTO_AND_SICK: GC.AccessRight.MANAGE_PTO_AND_SICK,
    MANAGE_GENERAL_SETTINGS: GC.AccessRight.MANAGE_GENERAL_SETTINGS,
    MANAGE_LICENSE: GC.AccessRight.MANAGE_LICENSE,

    AP_MANAGE_GENERAL_SETTINGS: GC.AccessRight.ACCOUNT_SETTINGS_MANAGER,
}

export const UserManagementConstants = GC.UserManagementConstants

export const DEFAULT_TIME_ZONE_GROUP_ID = GC.DEFAULT_TIME_ZONE_GROUP_ID
export const USERS_WITHOUT_GROUP_ID = GC.USERS_WITHOUT_GROUP_ID
export const DEFAULT_PERMISSIONS_TEMPLATE_ID = GC.DEFAULT_PERMISSIONS_TEMPLATE_ID
export const NON_BILLABLE_DEFAULT_TYPE_ID = window.__GENERATED_CONSTANTS__.NON_BILLABLE_DEFAULT_TYPE_ID

export const CalendarFrequencyType = {
    WEEKLY: GC.CalendarFrequencyType.WEEKLY,
    BIWEEKLY: GC.CalendarFrequencyType.BIWEEKLY,
    SEMI_MONTHLY: GC.CalendarFrequencyType.SEMI_MONTHLY,
    MONTHLY: GC.CalendarFrequencyType.MONTHLY,
    YEARLY: GC.CalendarFrequencyType.YEARLY,
    ON_HIRE_DATE: GC.CalendarFrequencyType.ON_HIRE_DATE,

    descriptionFor: GC.CalendarFrequencyType.descriptionFor,

    parametersFormatterFor: GC.CalendarFrequencyType.parametersFormatterFor
}

export const ProductVersion = {
    isOlVersion: GC.ProductVersion.isOlVersion,
    isDemoVersion: GC.ProductVersion.isDemoVersion
}

export const LicenseInfo = {
    isAtActive: GC.LicenseInfo.isAtActive,
    isApActive: GC.LicenseInfo.isApActive,
}

export const PRODUCTS_INTEGRATED = GC.PRODUCTS_INTEGRATED

export const LeaveBalanceCorrectionType = {
    ADD: GC.LeaveBalanceCorrectionType.ADD,
    SUB: GC.LeaveBalanceCorrectionType.SUB,
    SET: GC.LeaveBalanceCorrectionType.SET,
}

export const LeaveBalanceUnits = {
    HOURS: GC.LeaveBalanceUnits.HOURS,
    DAYS: GC.LeaveBalanceUnits.DAYS
}

export const LeaveTypeSelectionQualifier = {
    ALL: GC.LeaveTypeSelectionQualifier.ALL,
    SELECTED: GC.LeaveTypeSelectionQualifier.SELECTED
}

export const OTHER_USERS_ENTITY_ID = GC.OTHER_USERS_ENTITY_ID
export const OTHER_USER_GROUPS_ENTITY_ID = GC.OTHER_USER_GROUPS_ENTITY_ID

export const HierarchyLevels = {
    CUSTOMER: "CUSTOMER",
    PROJECT: "PROJECT",
    TASK: "TASK"
}

export const MAX_RATE = GC.MAX_RATE

export const Pager = {
    CUSTOM_PAGE_SET_2: [10, 25, 50, 100, 150],
}

export const DateRangeSelectionQualifier = {
    CURRENT_MONTH: GC.DateRangeSelectionQualifier.CURRENT_MONTH,
    CURRENT_MONTH_TILL_TODAY: GC.DateRangeSelectionQualifier.CURRENT_MONTH_TILL_TODAY,
    PREVIOUS_MONTH: GC.DateRangeSelectionQualifier.PREVIOUS_MONTH,
    NEXT_MONTH: GC.DateRangeSelectionQualifier.NEXT_MONTH,
    CURRENT_WEEK: GC.DateRangeSelectionQualifier.CURRENT_WEEK,
    CURRENT_WEEK_TILL_TODAY: GC.DateRangeSelectionQualifier.CURRENT_WEEK_TILL_TODAY,
    NEXT_WEEK: GC.DateRangeSelectionQualifier.NEXT_WEEK,
    PREVIOUS_WEEK: GC.DateRangeSelectionQualifier.PREVIOUS_WEEK,
    CURRENT_AND_PREVIOUS_WEEK: GC.DateRangeSelectionQualifier.CURRENT_AND_PREVIOUS_WEEK,
    CURRENT_AND_TWO_PREVIOUS_WEEKS: GC.DateRangeSelectionQualifier.CURRENT_AND_TWO_PREVIOUS_WEEKS,
    LAST_7_DAYS: GC.DateRangeSelectionQualifier.LAST_7_DAYS,
    LAST_14_DAYS: GC.DateRangeSelectionQualifier.LAST_14_DAYS,
    LAST_21_DAYS: GC.DateRangeSelectionQualifier.LAST_21_DAYS,
    CURRENT_YEAR: GC.DateRangeSelectionQualifier.CURRENT_YEAR,
    CURRENT_YEAR_TILL_TODAY: GC.DateRangeSelectionQualifier.CURRENT_YEAR_TILL_TODAY,
    PREVIOUS_YEAR: GC.DateRangeSelectionQualifier.PREVIOUS_YEAR,
    CURRENT_QUARTER: GC.DateRangeSelectionQualifier.CURRENT_QUARTER,
    PREVIOUS_QUARTER: GC.DateRangeSelectionQualifier.PREVIOUS_QUARTER,
    CUSTOM: GC.DateRangeSelectionQualifier.CUSTOM
}

export const EvaDateQualifier = {
    TODAY: GC.EvaDateQualifier.TODAY,
    YESTERDAY: GC.EvaDateQualifier.YESTERDAY,

    LAST_MONDAY: GC.EvaDateQualifier.LAST_MONDAY,
    LAST_TUESDAY: GC.EvaDateQualifier.LAST_TUESDAY,
    LAST_WEDNESDAY: GC.EvaDateQualifier.LAST_WEDNESDAY,
    LAST_THURSDAY: GC.EvaDateQualifier.LAST_THURSDAY,
    LAST_FRIDAY: GC.EvaDateQualifier.LAST_FRIDAY,
    LAST_SATURDAY: GC.EvaDateQualifier.LAST_SATURDAY,
    LAST_SUNDAY: GC.EvaDateQualifier.LAST_SUNDAY,

    END_OF_PREVIOUS_MONTH: GC.EvaDateQualifier.END_OF_PREVIOUS_MONTH,
    BEGINNING_OF_CURRENT_MONTH: GC.EvaDateQualifier.BEGINNING_OF_CURRENT_MONTH,

    CUSTOM: GC.EvaDateQualifier.CUSTOM
}

export const SubmitTTFormConstants = {
        ADD_TASKS_ACTION: GC.SubmitTTForm.ADD_TASKS_ACTION,
        HIGHLIGHT_TASKS_ACTION: GC.SubmitTTForm.HIGHLIGHT_TASKS_ACTION,
        REMOVE_DELETED_TASK: GC.SubmitTTForm.REMOVE_DELETED_TASK,
        ADD_ALL_PREVIOUS_WEEK_TASKS_ACTION: GC.SubmitTTForm.ADD_ALL_PREVIOUS_WEEK_TASKS_ACTION,
        ADD_REPORTED_PREVIOUS_WEEK_TASKS_ACTION: GC.SubmitTTForm.ADD_REPORTED_PREVIOUS_WEEK_TASKS_ACTION,
        SHOW_NEXT_READY_WEEK: GC.SubmitTTForm.SHOW_NEXT_READY_WEEK,
        SHOW_PREV_READY_WEEK: GC.SubmitTTForm.SHOW_PREV_READY_WEEK,
        ENTER_TT_RELOAD_ACTION: GC.SubmitTTForm.ENTER_TT_RELOAD_ACTION,
        REOPEN_TASK_ACTION: GC.SubmitTTForm.REOPEN_TASK_ACTION,
}

export const TimeApprovalStatus = {
    APPROVED: GC.TimeApprovalStatus.APPROVED,
    NOT_APPROVED: GC.TimeApprovalStatus.NOT_APPROVED,
    BOTH: GC.TimeApprovalStatus.BOTH
}

export const TimeFormat = {
    DECIMAL: GC.TimeFormat.DECIMAL,
    TIME: GC.TimeFormat.TIME
}

export const ReportConfigConstants = {
    LEAVES_REPORT_ALL_SELECTED_LEAVES_DELETED: GC.ReportConfigConstants.LEAVES_REPORT_ALL_SELECTED_LEAVES_DELETED,
    NO_RIGHTS_FOR_MANAGING_PTO_AND_SICK: GC.ReportConfigConstants.NO_RIGHTS_FOR_MANAGING_PTO_AND_SICK,
    ALL_SELECTED_FOR_REPORT_USERS_WERE_DELETED: GC.ReportConfigConstants.ALL_SELECTED_FOR_REPORT_USERS_WERE_DELETED,
    ALL_SELECTED_FOR_REPORT_PROJECTS_ARE_UNAVAILABLE_OR_DELETED: GC.ReportConfigConstants.ALL_SELECTED_FOR_REPORT_PROJECTS_ARE_UNAVAILABLE_OR_DELETED,
    OVERTIME_FOR_ALL_SELECTED_USERS_WAS_DISABLED: GC.ReportConfigConstants.OVERTIME_FOR_ALL_SELECTED_USERS_WAS_DISABLED,
    NO_BILLABLE_TASKS: GC.ReportConfigConstants.NO_BILLABLE_TASKS,
    SAVED_REPORTS_PAGE_URL: GC.ReportConfigConstants.SAVED_REPORTS_PAGE_URL,
    REPORTS_DASHBOARD_URL: GC.ReportConfigConstants.REPORTS_DASHBOARD_URL
}

export const StaffPerformanceColumnsConfig = {
    USERS_ONLY: GC.StaffPerformanceColumnsConfig.USERS_ONLY,
    GROUPS_ONLY: GC.StaffPerformanceColumnsConfig.GROUPS_ONLY,
    USERS_BY_GROUPS_WITHOUT_SUBTOTALS: GC.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS,
    USERS_BY_GROUPS_WITH_SUBTOTALS: GC.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS,
    TZ_GROUPS_ONLY: GC.StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY,
    USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS: GC.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS,
    USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS: GC.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS
}

export const BillingSummaryReportInfo = {
    TIME_ON_BILLABLE_TASKS: GC.BillingSummaryReportInfo.TIME_ON_BILLABLE_TASKS,
    TIME_ON_NON_BILLABLE_TASKS: GC.BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS,
    TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS: GC.BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS,
    BILLABLE_AMOUNT: GC.BillingSummaryReportInfo.BILLABLE_AMOUNT,
    BILLABLE_TIME_AND_BILLABLE_AMOUNT: GC.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT,
    BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES: GC.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES
}

export const ReportColumnsFormatCostOfWork = {
    USERS_ONLY : GC.ReportColumnsFormatCostOfWork.USERS_ONLY,
    GROUPS_ONLY: GC.ReportColumnsFormatCostOfWork.GROUPS_ONLY,
    USERS_BY_GROUPS: GC.ReportColumnsFormatCostOfWork.USERS_BY_GROUPS
}

export const ManagementAssignmentsSelection = {
    SELECTED: GC.ManagementAssignmentsSelection.SELECTED,
    ALL: GC.ManagementAssignmentsSelection.ALL,
    NO: GC.ManagementAssignmentsSelection.NO
}

export const WeekApprovalStatus = {
    NOT_READY: GC.WeekApprovalStatus.NOT_READY,
    READY: GC.WeekApprovalStatus.READY,
    APPROVED: GC.WeekApprovalStatus.APPROVED,
    REJECTED: GC.WeekApprovalStatus.REJECTED,
}

export const EntityTextLimits = {
    MAX_CPT_NAME: GC.EntityTextLimits.MAX_CPT_NAME,
    MAX_CPT_DESCRIPTION: GC.EntityTextLimits.MAX_CPT_DESCRIPTION,
    MAX_CPT_COMMENT: GC.EntityTextLimits.MAX_CPT_COMMENT,
    MAX_TT_COMMENT: GC.EntityTextLimits.MAX_TT_COMMENT,
    MAX_BILLING_TYPE_NAME: GC.EntityTextLimits.MAX_BILLING_TYPE_NAME,
    MAX_LEAVE_TYPE_NAME: GC.EntityTextLimits.MAX_LEAVE_TYPE_NAME,
    MAX_WORKFLOW_STATUS_NAME: GC.EntityTextLimits.MAX_WORKFLOW_STATUS_NAME,
    CUSTOM_FIELD_STRING_VALUE: 2000,
}

export const PasswordPolicyLengthRange = {
    MIN_PASSWORD_LENGTH: GC.PasswordValidators.MIN_PASSWORD_LENGTH,
    MAX_PASSWORD_LENGTH: GC.PasswordValidators.MAX_PASSWORD_LENGTH,
}

export const OvertimeTrackingLevel = {
    HIDDEN: GC.OvertimeTrackingLevel.HIDDEN,
    READONLY: GC.OvertimeTrackingLevel.READONLY,
    TRUSTED: GC.OvertimeTrackingLevel.TRUSTED,
}

export const ReportType = {
    STAFF_PERFORMANCE: GC.ReportType.STAFF_PERFORMANCE,
    OVERTIME: GC.ReportType.OVERTIME,
    LEAVE_TIME: GC.ReportType.LEAVE_TIME,
    TIME_TRACK_IN_DETAIL: GC.ReportType.TIME_TRACK_IN_DETAIL,
    ESTIMATED_VS_ACTUAL: GC.ReportType.ESTIMATED_VS_ACTUAL,

    BILLING_SUMMARY: GC.ReportType.BILLING_SUMMARY,
    INVOICING: GC.ReportType.INVOICING,
    COST_OF_WORK: GC.ReportType.COST_OF_WORK,
    PROFIT_LOSS: GC.ReportType.PROFIT_LOSS,
}

export const ReportChartType = {
    TOTAL_WORKING_HOURS: GC.ReportChartType.TOTAL_WORKING_HOURS,
    APPROVED_WORKING_HOURS: GC.ReportChartType.APPROVED_WORKING_HOURS,
    LEAVE_HOURS: GC.ReportChartType.LEAVE_HOURS,
    PTO_BALANCE: GC.ReportChartType.PTO_BALANCE,
    SICK_DAYS_BALANCE: GC.ReportChartType.SICK_DAYS_BALANCE,
    OVERTIME_HOURS: GC.ReportChartType.OVERTIME_HOURS,
    COST_OF_WORK: GC.ReportChartType.COST_OF_WORK,
    BILLABLE_AMOUNTS: GC.ReportChartType.BILLABLE_AMOUNTS,
}

export const ProductWebSiteURLs = {
    CURRENT_PRODUCT_SITE_URL: GC.ProductWebSiteURLs.CURRENT_PRODUCT_SITE_URL,
    USER_GUIDE_URL: GC.ProductWebSiteURLs.USER_GUIDE_URL,
    QBI_INTEGRATOR_GUIDE_URL: GC.ProductWebSiteURLs.QBI_INTEGRATOR_GUIDE_URL,
    SERVICE_AGREEMENT_URL: GC.ProductWebSiteURLs.SERVICE_AGREEMENT_URL,
    DATA_PROCESSING_AGREEMENT_URL: GC.ProductWebSiteURLs.DATA_PROCESSING_AGREEMENT_URL,

    OTHER_PRODUCT_WEB_SITE_URL: GC.ProductWebSiteURLs.OTHER_PRODUCT_WEB_SITE_URL,
    OTHER_PRODUCT_SERVICE_AGREEMENT_URL: GC.ProductWebSiteURLs.OTHER_PRODUCT_SERVICE_AGREEMENT_URL,
    OTHER_PRODUCT_DATA_PROCESSING_AGREEMENT_URL: GC.ProductWebSiteURLs.OTHER_PRODUCT_DATA_PROCESSING_AGREEMENT_URL,
    OTHER_PRODUCT_INTEGRATION_URL: GC.ProductWebSiteURLs.OTHER_PRODUCT_INTEGRATION_URL,
}

export const RequestVerification = {
    FORM_INPUT_NAME: GC.RequestVerification.FORM_INPUT_NAME,
    FORM_INPUT_VALUE: GC.RequestVerification.FORM_INPUT_VALUE,
}

export const PRODUCT_SWITCHER_URL = GC.PRODUCT_SWITCHER_URL

export const TASK_MANAGEMENT_RELATIVE_PATH = 'tasks/tasklist.do'
export const REPORT_LOGO_PATH = window.__GENERATED_CONSTANTS__.REPORT_LOGO_PATH
export const INTERFACE_LOGO_PATH = window.__GENERATED_CONSTANTS__.INTERFACE_LOGO_PATH

export const EnterTT = GC.EnterTT

export const Browser = {
    CHROME: 'chrome',
    SAFARI: 'safari',
    EDGE: 'edge',
    IE: 'ie',
    FIREFOX: 'firefox',
    OPERA: 'opera',
    OTHER: 'other',
}



// WEBPACK FOOTER //
// ./web/js/constants.js